/* eslint-disable sciencepo-rules/require-story*/
/* Ce test plus facilement avec ses composants parents*/
import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import IconContainer from '../shared/IconContainer';
import RelatedContent from './RelatedContent';
import * as pageStyles from '../../styles/internal-page/internal-page.module.scss';

const OpenedRelatedContents = React.memo(function OpenedRelatedContents ({
  related_contents,
  handleClickBack
}) {
  const { t } = useTranslation();
  React.useEffect(() => {
    function handleResize () {
      if (window.innerWidth > 1250) {
        handleClickBack();
      }
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <div className={pageStyles.rootContainer}>
      <div className={pageStyles.rootItem}>
        <button
          className={pageStyles.marginBetweenBlocsRelatedContent}
          onClick={() => handleClickBack()}
        >
          <div className={pageStyles.iconRelatedContent}>
            <IconContainer color="BLACK"
              icon="ARROW_LEFT_NORMAL"
              size={15}
            />
          </div>
          <p className={pageStyles.backButton}>
            {t('back.label')}
          </p>
        </button>
        {related_contents?.map((elem, index) => {
          return (
            <RelatedContent elem={elem.content[0]}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
});

OpenedRelatedContents.propTypes = {
  handleClickBack: PropTypes.func.isRequired,
  related_contents: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default OpenedRelatedContents;
